import React, {useEffect} from "react";
import "./SwitchButton.css"

class MyGroupSwitchButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            initialClass: "my-switch-button-outline-success",
            selectedClass: "my-switch-button-success",

            initialTextKey: this.props.initialTextKey ? this.props.initialTextKey : "toggle-",
            initialTextValue: this.props.initialTextValue ? this.props.initialTextValue : "Toggle ",
            maxLength: 0,
            activeIndex: this.props.selectedIndex !== undefined ? this.props.selectedIndex : undefined,
            activeItem: undefined,
            buttons: [],
            isFirst: true
        }
    }

    setButtons() {
        const _buttons = []

        for (let i = 0; i !== this.props.count; i++) {
            let model = {
                key: this.state.initialTextKey + i.toString(),
                value: this.state.initialTextValue + i.toString(),
                extra: undefined
            }
            const tmp = this.props.texts

            if (tmp && tmp[i] && 'key' in tmp[i] && 'value' in tmp[i]) {
                model = {
                    key: this.props.texts[i].key,
                    value: this.props.texts[i].value,
                    extra: this.props.texts[i].extra
                }
            }

            _buttons.push(model)
        }
        this.setState({
            buttons: _buttons
        })
    }

    async turnOff() {
        await this.setState({
            currentText: this.state.initialTextValue
        })
        await this.setState({
            currentClass: this.state.initialClass
        })
    }

    componentDidMount() {
        this.setButtons()
    }

    setSelected(item, index) {
        this.setState({
            activeIndex: index,
            activeItem: item
        })
    }

    getButtonClassAndSetSelected(item, index) {
        if (this.state.activeIndex !== undefined && this.state.activeIndex === index) {
            // Check if this is first initialize. if it is, call initialize callback function
            if (!this.state.activeItem &&
                this.props.onSwitch &&
                typeof this.props.onSwitch === 'function' &&
                this.state.isFirst
            ) {
                this.props.onSwitch(item, index)
                this.setSelected(item, index)
                this.setState({
                    isFirst: false
                })
            }
            return this.state.selectedClass
        } else {
            return this.state.initialClass
        }
    }

    handleOnSwitch(item, index) {
        if (this.state.activeItem.key !== item.key) {
            typeof this.props.onSwitch === "function" ? this.props.onSwitch(item, index) : void 0
        }
    }

    render() {
        return (
            this.state.buttons.map((item, index) =>
                <button
                    className={"my-switch-button " + this.getButtonClassAndSetSelected(item, index)}
                    type="button"
                    onClick={() => {
                        this.handleOnSwitch(item, index)
                        this.setSelected(item, index);
                    }}
                    style={{
                        margin: "4px"
                    }}
                >
                    {item.value}
                </button>
            )

        );
    }
}

export default MyGroupSwitchButton;
